/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_HoldInputs */

const en_us2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect, hold still.`)
};

const pt_br2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfeito, segure.`)
};

const es_419_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto, no te muevas.`)
};

const pt_pt2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfeito, não te mexas.`)
};

const fr_fr2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfait, ne bouge plus.`)
};

const de_de2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt, stillhalten.`)
};

const it_it2_body_assessment_cue_hold = /** @type {(inputs: Body_Assessment_Cue_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfetto, resta fermo.`)
};

/**
* | output |
* | --- |
* | "Perfect, hold still." |
*
* @param {Body_Assessment_Cue_HoldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_hold = /** @type {((inputs?: Body_Assessment_Cue_HoldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_HoldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_hold(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_hold(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_hold(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_hold(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_hold(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_hold(inputs)
	return en_us2_body_assessment_cue_hold(inputs)
});
export { body_assessment_cue_hold as "body-assessment.cue.hold" }